import { useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import vcreateLogo from '../images/Vcreate-logo.svg';

const Navbar = () => {
  // Check if the user is signed in and if they're an admin
  const { userToken, userRole, signOut } = useAuth();
//   const userIsAdmin = true;
  const user = userRole != null;
  const userIsAdmin = userRole == "Admin";

  // To determine the active route:
  const location = useLocation();

  const tglbtnRef = useRef<HTMLDivElement>(null);
  const navlstRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const tglbtn = tglbtnRef.current;
    const navlst = navlstRef.current;

    const toggleNav = () => {
      if (navlst) {
        navlst.classList.toggle("navbar-active");
      }
    };

    if (tglbtn && navlst) {
      tglbtn.addEventListener('click', toggleNav);
    }

    // Cleanup the event listener when the component unmounts
    return () => {
      if (tglbtn) {
        tglbtn.removeEventListener('click', toggleNav);
      }
    };
  }, []);

  return (
        <nav id="navbar">
        <div className="logo-container">
            <a href="/" title="Vcreate logo">
                <img className="logo-image" src={vcreateLogo} alt="Vcreate logo" title="Vcreate logo"/>
            </a>
        </div>
        <div id="nav-list" className="nav-menu" ref={navlstRef}>
            {location.pathname.includes("/jobs") && <Link to={location.pathname} className="active">View Job</Link>}
            {location.pathname.includes("/users") && <Link to={location.pathname} className="active">View User</Link>}
            <Link to="/" className={location.pathname === "/" ? "active first-child" : "inactive first-child"}>TAPIR</Link>
            <Link to="/tutorial" className={location.pathname === "/tutorial" ? "active" : "inactive"}>Tutorial</Link>
            {!user && <Link to="/signin" className={location.pathname === "/signin" ? "active" : "inactive"}>Sign In</Link>}
            {!user && <Link to="/signup" className={location.pathname === "/signup" ? "active" : "inactive"}>Sign Up</Link>}
            {user && <Link to="#" className="inactive" onClick={signOut}>Sign Out</Link>}      
            {userIsAdmin && <Link to="/admin" className={location.pathname === "/admin" ? "active" : "inactive"}>Admin</Link>}
        </div>
        <div id="burger-menu" className="menu-icon" ref={tglbtnRef}>
            <div className="bar top"></div>
            <div className="bar"></div>
            <div className="bar"></div>
        </div>
    </nav>
  );
}

export default Navbar;